import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { Heart, Send } from 'lucide-react';

export default function Pitches() {
 const [pitches, setPitches] = useState([]);
 const [form, setForm] = useState({ title: '', description: '', photo_base64: '' });
 const [loading, setLoading] = useState(false);

 const load = async () => {
 const { data } = await api.get('/founders/pitches');
 setPitches(data.pitches || []);
 };

 useEffect(() => { load(); }, []);

 const submit = async (e) => {
 e.preventDefault();
 setLoading(true);
 try {
 await api.post('/founders/pitches', form);
 setForm({ title: '', description: '', photo_base64: '' });
 await load();
 } finally { setLoading(false); }
 };

 const readFile = (file) => new Promise((res, rej) => {
 const r = new FileReader();
 r.onerror = rej; r.onload = () => res(r.result);
 r.readAsDataURL(file);
 });

 const onFile = async (e) => {
 const f = e.target.files?.[0];
 if (!f) return;
 if (f.size > 2_000_000) { alert('Please choose an image under 2MB'); return; }
 const b64 = await readFile(f);
 setForm({ ...form, photo_base64: b64 });
 };

 const vote = async (id) => {
 await api.post(`/founders/pitches/${id}/vote`);
 await load();
 };

 return (
 <div className="space-y-6">
 <Panel className="p-8">
 <div className="h-eyebrow">Pitch an Apparel Idea</div>
 <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Help shape the next Heritage release</div>
 </Panel>

 <Panel className="p-6">
 <form onSubmit={submit} className="grid md:grid-cols-2 gap-4">
 <div>
 <label className="h-label">Title</label>
 <input className="h-input" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="pitch-title" />
 </div>
 <div>
 <label className="h-label">Photo / Sketch (optional)</label>
 <input type="file" accept="image/*" onChange={onFile} className="text-sm" data-testid="pitch-photo" />
 </div>
 <div className="md:col-span-2">
 <label className="h-label">Description</label>
 <textarea className="h-input" rows={4} required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="pitch-description" />
 </div>
 <div className="md:col-span-2">
 <button className="h-btn" disabled={loading} data-testid="pitch-submit">
 <Send size={14} className="mr-2" /> {loading ? 'Submitting...' : 'Submit pitch'}
 </button>
 </div>
 </form>
 </Panel>

 <div>
 <div className="h-eyebrow mb-3">Community pitches</div>
 <div className="grid md:grid-cols-2 gap-6">
 {pitches.map(p => (
 <Panel key={p.id} className="p-6">
 <div className="flex justify-between items-start">
 <div>
 <div className="h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>{p.title}</div>
 <div className="h-eyebrow mt-1">by {p.user_name || 'Anonymous'}</div>
 </div>
 <button onClick={() => vote(p.id)} className="h-btn-outline text-xs flex items-center gap-1" data-testid={`pitch-vote-${p.id}`}>
 <Heart size={14} fill={p.has_voted ? 'currentColor' : 'none'} /> {p.votes}
 </button>
 </div>
 {p.photo_base64 && (
 <img src={p.photo_base64.startsWith('data:') ? p.photo_base64 : `data:image/png;base64,${p.photo_base64}`}
 alt={p.title} className="w-full max-h-56 object-cover rounded-lg mt-3" />
 )}
 <p className="text-sm mt-3 opacity-85" style={{ color: 'var(--heritage-plum)' }}>{p.description}</p>
 </Panel>
 ))}
 {pitches.length === 0 && <div className="text-sm opacity-70" style={{ color: 'var(--heritage-plum)' }}>No pitches yet. be the first.</div>}
 </div>
 </div>
 </div>
 );
}
